import React, { useState } from 'react'
import {
  CFImage,
  CFView,
  CFText,
  DefaultScreen,
  MobileScreen,
  PrimaryModal,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import DeliveryModal from './DeliveryModal'
import { hero, mobileLogo, mobileHero, orderDeliveryButton } from 'images'

export default () => {
  const [showModal, setShowModal] = useState(false)
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="95vh"
          maxHeight="750px"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          justifyBetween
          alignCenter
        >
          <CFView b w="100%" column center pv="4px" bg="rgba(0,0,0,.7)">
            <CFImage src={mobileLogo} w="70%" maxWidth="350px" alt="About" />
          </CFView>
          <CFView w="100%" column center textCenter>
            <CFView pulsate textCenter w="100%">
              <OrderPickupButton />
            </CFView>
            <CFView hover pv="15px" onClick={() => setShowModal(true)}>
              <CFImage
                maxWidth="260px"
                src={orderDeliveryButton}
                alt="Order delivery"
              />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="650px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignCenter
        >
          <Header />
          <CFView row center bg="rgba(0,0,0,.8)" ph="60px" pv="2px">
            {/* <CFImage
              h="35px"
              src={heroText}
              alt="I Love Sushi Logo"
              zIndex={98}
              pv="5px"
            /> */}
            <CFView row center mt="5px">
              <CFView ml="30px" pulsate>
                <OrderPickupButton />
              </CFView>
              <CFView
                hover
                pt="3px"
                ml="15px"
                onClick={() => setShowModal(true)}
              >
                <CFImage
                  maxWidth="220px"
                  src={orderDeliveryButton}
                  alt="Order delivery"
                />
              </CFView>
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
      <DeliveryModal
        showModal={showModal}
        onRequestClose={() => setShowModal(false)}
      />
    </CFView>
  )
}
